export enum AccountType {
    Admin = 1,
    PrivateLandlord = 2,
    CorporateLandlord = 3,
    Tenant = 4,
    Agent = 5,
    None = 100,
}

export enum AuthMethod {
    Email = 1,
    Sms = 2,
}

export enum UserStatus {
    Inactive = 1,
    Dormant = 2,
    Active = 3,
}

export enum ReleaseRequestStatus {
    Draft = 1,
    Negotiation = 21,
    Accepted = 31,
    Settled = 41,
    Closed = 46,
    ClosedInternal = 47,
    Resolution = 51,
    Canceled = 61,
}

export enum SettlementStatus {
    Negotiation = 1,
    Accepted = 2,
    Deleted = 3,
}

export enum ProposedBy {
    None = 0,
    LeadTenant = 1,
    PropertyManager = 2,
}

export enum DisputeType {
    ADR = 0,
    Court = 1,
}

export enum TenancyStatuses {
    Vacant = 1,
    PreApproved = 10,
    Live = 11,
    PendingTenantAction = 41,
    PendingAgentAction = 51,
    PendingLandlordAction = 61,
}

export enum ManagedBy {
    Agency = 1,
    Landlord = 2,
}

export enum EvidenceIconType {
    Loading = 0,
    Document = 1,
    Picture = 2,
}

export enum TimeFrameStatus {
    CanBeOpenInFuture = 1,
    CanBeOpen = 2,
    CanNotBeOpen = 3,
}

export enum OnBehalfOfTypes {
    None = 0,
    LeadTenant = 1,
    PropertyManager = 2,
}

export enum ClaimStatusEnum {
    NotExists = -1,
    Open = 1,
    OpenAccepted = 11,
    OpenDeclined = 21,
    ClosedAccepted = 31,
    ClosedDeclined = 41,
    ClosedAcceptedPartially = 51,
}

export enum AddressLocalizationId {
    AddressFirstLabel = "company-form-address.address_first_label",
    AddressFirstPlaceholder = "company-form-address.address_first_placeholder",
    AddressSecondLabel = "company-form-address.address_second_label",
    AddressSecondOptionalLabel = "company-form-address.address_second_optional_label",
    AddressSecondPlaceholder = "company-form-address.address_second_placeholder",
    AddressPostcodeLabel = "company-form-address.address_postcode_label",
    AddressCityLabel = "company-form-address.address_city_label",
    AddressCountryLabel = "company-form-address.address_country_label",
}

export enum TenancyTenantStatusEnum {
    Pending = 1,
    PreApproved = 2,
    Live = 3,
}

export enum EndOfTenancyType {
    Split = 1,
    Swap = 2,
    Exit = 3,
}

export enum ActivityActions {
    Create = 1,
    Update = 2,
    Delete = 3,
    Invite = 4,
    Login = 5,
}
